import { TourState, Tour } from '../models/interfaces'

/**
 * Tipos de mutaciones para el módulo de tour
 */
export enum MutationTypes {
  SET_ACTIVE_TOUR = 'SET_ACTIVE_TOUR',
  SET_CURRENT_STEP = 'SET_CURRENT_STEP',
  SET_IS_ACTIVE = 'SET_IS_ACTIVE',
  ADD_TO_HISTORY = 'ADD_TO_HISTORY',
  SET_TOUR_ENABLED = 'SET_TOUR_ENABLED',
  RESET_TOUR = 'RESET_TOUR',
}

/**
 * Mutaciones del módulo de tour
 */
export const mutations = {
  [MutationTypes.SET_ACTIVE_TOUR] (state: TourState, tour: Tour | null) {
    state.activeTour = tour
  },

  [MutationTypes.SET_CURRENT_STEP] (state: TourState, stepIndex: number) {
    state.currentStepIndex = stepIndex
  },

  [MutationTypes.SET_IS_ACTIVE] (state: TourState, isActive: boolean) {
    state.isActive = isActive
  },

  [MutationTypes.ADD_TO_HISTORY] (state: TourState, tourId: string) {
    if (!state.tourHistory.includes(tourId)) {
      state.tourHistory.push(tourId)
    }
  },

  [MutationTypes.SET_TOUR_ENABLED] (state: TourState, enabled: boolean) {
    state.isTourEnabled = enabled
  },

  [MutationTypes.RESET_TOUR] (state: TourState) {
    state.activeTour = null
    state.currentStepIndex = 0
    state.isActive = false
  },
}
